<template>

    <div class="footer footer--reopen" >
        <div class="container">
            <div class="columns">
                <div class="column">
                    &nbsp;
                </div>
                <div class="column has-text-centered">
                    <button type="button" class="btn-invite"
                            @click="adjustQuote"
                            v-bind:disabled="reopening || reopenedSuccess || reopenErrorMessage !== ''">
                        <span v-show="reopenedSuccess === true"><i class="fas fa-check"></i>&nbsp;&nbsp;</span>
                        <span v-show="reopenedSuccess === false"><i class="fas fa-exclamation-triangle"></i>&nbsp;&nbsp; Error Reopening</span>
                        <span v-show="reopenedSuccess !== false"> REOPEN<span
                                v-show="reopenedSuccess === true && !reopening">ED</span><span
                                v-show="reopening === true">ING</span>&nbsp;QUOTE</span>
                        <span v-show="reopening"
                              class="button is-loading btn-loader white-loader" style="display: inline-flex"></span>
                    </button>
                    <div v-if="!reopenErrorMessage">
                         <span v-show="!reopening">You can adjust your quote until
                            {{dateDeadline}}</span>
                        <span v-show="reopening">Please wait</span>
                    </div>
                    <div v-else>
                        <span>{{reopenErrorMessage}}</span>
                    </div>
                </div>
                <div class="column">
                    &nbsp;
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
  name: 'ReOpen',
  props: ['dateSubmitted', 'dateDeadline', 'reopening', 'reopenedSuccess', 'reopenErrorMessage'],
  data () {
    return {}
  },
  methods: {
    adjustQuote () {
      this.$emit('adjustQuote')
    }
  }
}
</script>
